import React, { useState, useEffect } from 'react'
import i18n from 'i18n/index.js'
import { fetchWithLocale } from "components/utils/Api.jsx";
import OiCarousel from "components/shared/OiCarousel";

const REVIEWS_CAROUSEL_BREAKPOINTS = [
  { minWidth: 375, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 1.2 },
  { minWidth: 768, slidesPerView: 2.2 },
  { minWidth: 1024, slidesPerView: 3 },
  { minWidth: 1440, slidesPerView: 3 },
];

function ReviewRatingStars({ value }) {
    const r = Math.max(0, Math.min(5, Math.round(Number(value) || 0)))
    return (
        <span className="review-rating-stars" role="img" aria-label={`${r} / 5`}>
            {[0, 1, 2, 3, 4].map((i) => (
                <span
                    key={i}
                    className={
                        i < r
                            ? "review-rating-stars__star review-rating-stars__star--filled"
                            : "review-rating-stars__star"
                    }
                    aria-hidden
                >
                    ★
                </span>
            ))}
        </span>
    )
}

function CarouselHomeReviews(props) {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        get_reviews();
    }, []);

    function get_reviews() {
        setLoading(true)
        return fetchWithLocale(`/get_reviews.json${props.home_collection_id ? '?home_collection_id=' + props.home_collection_id : ''}`)
            .then(response => response.json())
            .then(json => {
                setReviews(json.reviews)
                setLoading(false)
            }
            )
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }


    return (
        !props.home_collection_id && (
                <section className="posts">
                    <header className="collections" key={"home_collection_id" + props.home_collection_title}>
                        <h2><b>{props.home_collection_title}</b> {props.home_collection_subtitle}</h2>
                    </header>
                    <section className="caroussel">
                        <section className="products-section">
                            {loading ? (
                                <section className="carousel-skeletons-loader carousel-home__skeleton-row">
                                    {Array.from({ length: 3 }).map((_, idx) => (
                                      <div
                                        key={`review-skeleton-${idx}`}
                                        className="carousel-home__skeleton-cell--card oi-skeleton oi-skeleton--wave oi-skeleton--rounded"
                                        style={{ height: 275 }}
                                        aria-hidden
                                      />
                                    ))}
                                </section>
                            ) : (
                                <OiCarousel
                                  items={reviews || []}
                                  gap={24}
                                  breakpoints={REVIEWS_CAROUSEL_BREAKPOINTS}
                                  ariaLabel="Reseñas"
                                  getItemKey={(review) => `reviews-label-${review.id}`}
                                  renderItem={(review) => (
                                    <div className="review-card">
                                      <div className="review-content">
                                        <div className="review-head">
                                          <figure className={['review-figure', props.home_class].filter(Boolean).join(' ')}>
                                            <img
                                              className=""
                                              alt={props.alt ? props.alt : ""}
                                              src={review.cover_url}
                                            />
                                          </figure>
                                          <div className="review-author">
                                            <span className="review-name">{review.author}</span>
                                            <p className="review-country">{review.country}</p>
                                            <span className="position_rating">
                                              <ReviewRatingStars value={review.rating} />
                                            </span>
                                          </div>
                                        </div>
                                        <p className="review-text">
                                          <span
                                            dangerouslySetInnerHTML={{ __html: review.body }}
                                          />
                                        </p>
                                        <p className="review-footer">
                                          <a href={review.url} target="_blank" rel="noreferrer">
                                            ★ {i18n.t("reviews.footer")}
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                />
                            )}
                        </section>
                    </section>
                </section>
        )
    );
}

export default CarouselHomeReviews
